import updateFieldSlice from "./../slices/updateFieldSlice";
import { combineReducers } from "@reduxjs/toolkit";
import finchatReducer from "../slices/finchatSlice";
import themeReducer from "../slices/themeSlice";
import { authReducer } from "./authReducer";
import notificationReducer from "../slices/notificationSlice";
import pastSessionSlice from "../slices/pastSessionSlice";
import sharedSessionSlice from "./../slices/sharedSessionSlice";
import promptsSlice from "../slices/promptsSlice";
import activePlanSlice from "../slices/activePlanSlice";
import activeUserSlice from "../slices/userSlice";
import fetchAuthToken from "../slices/fetchAuthToken";
import allPlanSlice from "../slices/allPlanSlice";
import websocketReducer from "../slices/websocketSlice";
import changeSubscriptionSlice from "../slices/changeSubscriptionSlice";
import deleteUserSlice from "../slices/deleteUserSlice";
import validateUserSlice from "../slices/validateUserSlice";
import IntroPromoSlice from "../slices/IntroPromoSlice";
import userPreferencesSlice from "../slices/userPreferencesSlice";
import changeLogsSlice from "../slices/changeLogsSlice";
import recommendedPromptsSlice from "../slices/recommendedPromptsSlice";
import watchlistSlice from "../slices/watchlistSlice";
import dxFeedSlice from "../slices/dxFeedSlice";
import userActivitiesSlice from "../slices/userActivitiesSlice";
import newsSummarySlice from "../slices/newsSummarySlice";
import responseCustomizationSlice from "../slices/responseCustomizationSlice";
import searchSlice from "../slices/searchSlice";
import taskSlice from "../slices/taskSlice";

const rootReducer = combineReducers({
  finchat: finchatReducer,
  theme: themeReducer,
  auth: authReducer,
  notification: notificationReducer,
  session: pastSessionSlice,
  sharedSession: sharedSessionSlice,
  prompts: promptsSlice,
  plan: activePlanSlice,
  user: activeUserSlice,
  token: fetchAuthToken,
  plans: allPlanSlice,
  updateFields: updateFieldSlice,
  websocket: websocketReducer,
  checkout: changeSubscriptionSlice,
  deleteUser: deleteUserSlice,
  validUser: validateUserSlice,
  introPromo: IntroPromoSlice,
  userPreferences: userPreferencesSlice,
  changeLogs: changeLogsSlice,
  recommendedPrompts: recommendedPromptsSlice,
  watchlist: watchlistSlice,
  dxFeed: dxFeedSlice,
  userActivities: userActivitiesSlice,
  newsSummary: newsSummarySlice,
  responseCustomization: responseCustomizationSlice,
  search: searchSlice,
  tasks: taskSlice,
});

export default rootReducer;
